import { Box, styled, Typography } from '@mui/material'
import CustomizeSkeleton from 'components/CustomizeSkeleton'
import { Carousel } from 'react-responsive-carousel'
import { useRecommends } from 'services/module/home'
import ProgressImg from 'assets/images/png/home/progress-bg.png'
import { useIsMobile } from 'hooks/useIsMobile'

const PcBox = styled(Box)`
  width: 100%;
  max-width: 2000px;
  height: 720px !important;
  margin-top: -56px;
  margin-left: auto;
  margin-right: auto;
  position: relative;
`

const PcImageBox = styled(Box)`
  width: 100%;
  height: 720px;
`

const MobileBox = styled(Box)`
  width: 100%;
  min-width: 100vw;
  height: 150vw !important;
  margin-top: -56px;
  margin-left: auto;
  margin-right: auto;
  position: relative;
`

const ImageBox = styled(Box)`
  width: 100%;
  height: 150vw !important;
`

const TextBox = styled(Box)`
  cursor: pointer;
  height: 264px;
  color: ${props => props.theme.colors.white};
  width: 100%;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: 23.5px;
  background: linear-gradient(to top, #000 0%, rgba(0, 0, 0, 0) 100%);
  overflow: hidden;
`
const TitleTypography = styled(Typography)`
  font-weight: 700;
  font-family: 'Roboto Condensed', sans-serif;
  font-size: 48px;
  line-height: 64px;
  text-align: left;
  position: absolute;
  left: 150px;
  top: 0;
  width: 466px;
  height: 192px;
`

const MobileText = styled(Box)`
  font-weight: 600;
  font-size: 32px;
  font-family: 'Roboto Condensed', sans-serif;
  line-height: 40px;
  color: ${props => props.theme.colors.white};
  width: 100%;
  padding: 0 16px;
  text-align: center;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: 23.5px;
  background: linear-gradient(to top, #000 0%, rgba(0, 0, 0, 0) 100%);
  overflow: hidden;
`

const CarouselBox = styled(Box)`
  .slider {
    z-index: 0;
    .slide {
      pointer-events: none;
    }
    .selected {
      pointer-events: auto;
    }
  }
  .control-dots {
    bottom: -10px !important;
    height: 24px;
    line-height: 24px;
    background: #000;
    margin-top: 0;
    .dot {
      width: 32px;
      height: 2px;
      border-radius: 0;
      transition: none;
      position: relative;
      :hover {
        opacity: 0.3;
        height: 2px;
      }
      @media (any-hover: hover) {
        :hover {
          outline: none !important;
          border: 0 !important;
          opacity: 1 !important;
          height: 4px !important;
          background-image: url(${ProgressImg});
          background-repeat: no-repeat;
        }
      }
      :active {
        outline: none !important;
        border: 0 !important;
        opacity: 1 !important;
        height: 4px !important;
        background-image: url(${ProgressImg});
        background-repeat: no-repeat;
      }
    }
    .selected {
      outline: none !important;
      border: 0 !important;
      opacity: 1 !important;
      height: 4px !important;
      background: none;
      background-image: url(${ProgressImg});
      background-repeat: no-repeat;
      animation: progressAnimation 4s linear infinite;
    }
  }
  @keyframes progressAnimation {
    0% {
      background-size: 32px 4px;
    }
    50% {
      background-size: 16px 4px;
    }
    100% {
      background-size: 1px 4px;
    }
  }
`

export function HomeCarousel() {
  const { rm, loading } = useRecommends()
  const isMobile = useIsMobile()
  return (
    <>
      <CarouselBox>
        <CustomizeSkeleton
          width="width: 100%"
          height={isMobile ? '183.47vw' : '56.25vw'}
          variant="rectangular"
          loading={loading}
        >
          <Carousel
            showArrows={false}
            showStatus={false}
            showThumbs={false}
            autoPlay={true}
            infiniteLoop={true}
            stopOnHover={false}
            interval={4000}
            animationHandler="fade"
            swipeable={false}
          >
            {rm &&
              rm.map(el =>
                isMobile ? (
                  <MobileBox
                    key={`carousel${el.id}`}
                    onClick={() => {
                      if (el.linkUrl) {
                        window.open(el.linkUrl)
                      }
                    }}
                  >
                    <ImageBox
                      sx={{
                        backgroundImage: `url(${el.verticalCover ? el.verticalCover : el.cover})`,
                        backgroundRepeat: 'no-repeat',
                        backgroundSize: 'cover',
                        backgroundPosition: 'top center',
                      }}
                    ></ImageBox>
                    <MobileText>{el.description}</MobileText>
                  </MobileBox>
                ) : (
                  <PcBox
                    key={`carousel${el.id}`}
                    onClick={() => {
                      if (el.linkUrl) {
                        window.open(el.linkUrl)
                      }
                    }}
                  >
                    <PcImageBox
                      sx={{
                        backgroundImage: `url(${el.cover})`,
                        backgroundRepeat: 'no-repeat',
                        backgroundSize: 'cover',
                        backgroundPosition: 'center center',
                      }}
                    ></PcImageBox>
                    <TextBox>
                      <TitleTypography>{el.description}</TitleTypography>
                    </TextBox>
                  </PcBox>
                )
              )}
          </Carousel>
        </CustomizeSkeleton>
      </CarouselBox>
    </>
  )
}
